import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  ListSubheader,
  Checkbox,
  ListItemText,
  Box,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import {
  getAllPrinciple,
  getAllPrincipleForDropDown,
  getPrincipleByPartnerId,
} from "../services/siteServices/principleServices";
import { getAllDomain } from "../services/DomainService/DomainService";
import { getAllRoles } from "../services/RoleService/RoleService";
import { getAllPartners } from "../services/PartnerService/PartnerService";
import {
  getAllOrganizations,
  getOrgsAndCompanies,
  getOrgsAndRoles,
} from "../services/OrganizationService/OrganizationService";
import { getAllCities } from "../services/siteServices/locationService";
import {
  getAllPackages,
  getAllPackagesByPrinciple,
} from "../services/siteServices/packageServices";
import { snakeCasetoTitleCase } from "../helpers/utils";
import { getStagesAndSubActivities } from "../services/ActivityHistoryService/ActivityHistoryService";
import { getStagesByPartnerId } from "../services/StageMasterService/StageMasterService";

const AddMasterTableDataModal = ({
  selectedTableDisplayName,
  open,
  onClose,
  onAddData,
  metadata,
  newData,
  setNewData,
  errors,
  setErrors,
  selectedTable,
  validateData,
  selectedDate,
  setSelectedDate,
  loading,
  setLoading,
}) => {
  const [data, setData] = useState([]);
  const minDate = moment().startOf("day");
  const [projects, setProjects] = useState([]);
  const [packages, setPackages] = useState([]);
  const [cities, setCities] = useState([]);
  const [stages, setStages] = useState([]);

  const [dependsOn, setDependsOn] = useState({});

  const handleAdd = () => {
    if (validateData()) {
      const phoneRegex = /^[6-9]\d{9}$/;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (newData.phone_number && !phoneRegex.test(newData.phone_number)) {
        return;
      }
      // Check if email is valid
      if (newData.email && !emailRegex.test(newData.email)) {
        return;
      }

      if (newData.ContactNumber && !phoneRegex.test(newData.ContactNumber)) {
        return;
      }
      // Check if email is valid
      if (newData.EmailID && !emailRegex.test(newData.EmailID)) {
        return;
      }

      if (newData.primary_email && !emailRegex.test(newData.primary_email)) {
        return;
      }

      onAddData();
      setSelectedDate({
        valid_from: "",
        valid_to: "",
        validTo: "",
        validFrom: "",
      });
    }
  };

  const handleChange = (e, column) => {
    const { value } = e.target;
    console.log("seterrors", setErrors);
    setErrors({
      ...errors,
      [column.column_name]: "", // Clear the error message for the column
    });
    setNewData({
      ...newData,
      [column.column_name]: value,
    });
  };

  const tableDataMap = {
    ActivityMasterMetadata: [getAllPartners],
    StageMaster: [getAllPartners],
    StakeHolderMaster: getOrgsAndCompanies,
    StructureDesignMaster: getAllOrganizations,
    PrincipleDetailsMaster: [getAllPartners],
    domain_master: getAllOrganizations,
    LocationMaster: getAllOrganizations,
    role_master: getAllOrganizations,
    partner_master: getAllDomain,
    user_role_mapping: getOrgsAndRoles,
    CompanyMaster: getAllOrganizations,
    Package: getAllPrincipleForDropDown,
    principle_city_package_mapping: [getAllPartners, getAllCities],
    status_master: [getAllPartners],
    remark_category_master: [getAllPartners],
    attachment_category_master: [getAllPartners],
    corporation_city_mapping: getAllCities,
  };

  useEffect(() => {
    // Function to fetch data based on the selected table
    async function fetchData() {
      try {
        setLoading(true);
        console.log("Table name:", selectedTable);

        const fetchFunction = tableDataMap[selectedTable];

        if (Array.isArray(fetchFunction)) {
          // Handle case where the value is an array of functions
          const responses = await Promise.all(fetchFunction.map((fn) => fn()));
          console.log("Array data:", responses);

          // Combine or set responses as needed
          console.log("responses---------->", responses);
          setData(responses);
        } else if (typeof fetchFunction === "function") {
          const response = await fetchFunction();
          console.log("Single data:", response);

          setData(response);
        } else {
          console.warn("No valid fetch function found for the selected table.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [selectedTable]);

  const GetData = (data, value) => {
    console.log("Data ", data);

    return data?.find((item) => item.id === value);
  };

  const ITEM_HEIGHT = 100;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const reorderedMetadata = metadata
    ? [
        ...metadata.filter((column) => column.column_name === "partner_id"),
        ...metadata.filter((column) => column.column_name !== "partner_id"),
      ]
    : [];
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
      <DialogTitle>Add New Data to {selectedTableDisplayName}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please fill out the following fields to add a new record:
        </DialogContentText>

        {!loading &&
          reorderedMetadata?.map((column) => {
            if (column.data_type === "timestamp without time zone") {
              return (
                <DatePicker
                  key={column.column_name}
                  label={snakeCasetoTitleCase(column.column_name)}
                  value={selectedDate[column.column_name] || null} // Set value based on specific column
                  onChange={(date) => {
                    const localDate = moment(date)
                      .startOf("day")
                      .format("YYYY-MM-DD HH:mm:ss");

                    setSelectedDate((prev) => ({
                      ...prev,
                      [column.column_name]: date,
                    }));

                    setErrors({
                      ...errors,
                      [column.column_name]: "", // Clear the error message for the column
                    });

                    setNewData({
                      ...newData,
                      [column.column_name]: localDate,
                    });
                  }}
                  minDate={
                    column.column_name === "validTo" ||
                    column.column_name === "valid_to"
                      ? minDate
                      : undefined
                  }
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      margin: "normal",
                      error: !!errors[column.column_name],
                      helperText: errors[column.column_name],
                    },
                  }}
                />
              );
            }

            if (
              column.column_name === "principle_name" &&
              selectedTable === "principle_city_package_mapping"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="domain-label">Principle Name</InputLabel>
                  <Select
                    labelId="principle-label"
                    label="Principle Name"
                    value={newData.principle_name || ""}
                    onChange={async (e) => {
                      setNewData({
                        ...newData,
                        principle_name: e.target.value,
                      });

                      const packageData = await getAllPackagesByPrinciple(
                        e.target.value
                      );
                      setErrors({
                        ...errors,
                        [column.column_name]: "", // Clear the error message for the column
                      });
                      console.log("packagaeData------->", packageData);
                      setPackages(packageData);
                    }}
                    error={!!errors.principle_name}
                  >
                    {projects.map((principle) => (
                      <MenuItem
                        key={principle.ProjectID}
                        value={principle.ProjectName}
                      >
                        {principle.ProjectName}
                      </MenuItem>
                    ))}
                  </Select>

                  {errors.principle_name && (
                    <FormHelperText>{errors.principle_name}</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (
              column.column_name === "package_name" &&
              selectedTable === "principle_city_package_mapping"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="domain-label">Package Name</InputLabel>
                  <Select
                    labelId="domain-label"
                    label="Package Name"
                    value={newData.package_name || ""}
                    // onChange={async (e) => {
                    //   setNewData({
                    //     ...newData,
                    //     package_name: e.target.value,
                    //   });
                    // }}
                    onChange={(e) => handleChange(e, column)}
                    error={!!errors.PackageName}
                  >
                    {packages.map((pack, index) => (
                      <MenuItem key={index} value={pack.PackageName}>
                        {pack.PackageName}
                      </MenuItem>
                    ))}
                  </Select>

                  {errors._name && (
                    <FormHelperText>{errors.PackageName}</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (
              column.column_name === "principle_name" &&
              selectedTable === "Package"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="domain-label">Principle Name</InputLabel>
                  <Select
                    labelId="domain-label"
                    label="Principle Name"
                    value={newData.principle_name || ""}
                    onChange={(e) =>
                      setNewData({
                        ...newData,
                        principle_name: e.target.value,
                      })
                    }
                    error={!!errors.principle_name}
                  >
                    {!loading &&
                      data?.principles?.map((prinicple) => (
                        <MenuItem
                          key={prinicple.ProjectID}
                          value={prinicple.ProjectName}
                        >
                          {prinicple.ProjectName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.principle_name && (
                    <FormHelperText>{errors.principle_name}</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (column.column_name === "location_name") {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="partner-id-label">Location Name</InputLabel>
                  <Select
                    labelId="partner-id-label"
                    label="Location Name"
                    value={newData.location_name || ""}
                    // onChange={async (e) => {
                    //   // console.log("Data111 ------> ", e.target.value;

                    //   // console.log("location_nameeeeeeeeeeee", e.target);

                    //   setNewData({
                    //     ...newData,
                    //     location_name: e.target.value,
                    //     // partner_id: e.target.value,
                    //   });
                    // }}
                    onChange={(e) => handleChange(e, column)}
                    // error={!!errors.partner_id}
                  >
                    {!loading &&
                      data[1]?.map((location_name) => (
                        <MenuItem
                          key={location_name.LocationID}
                          value={location_name.CityName}
                        >
                          {location_name.CityName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.location_name && (
                    <FormHelperText>Location Name is Required</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (column.column_name === "city_name") {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="partner-id-label">City Name</InputLabel>
                  <Select
                    labelId="partner-id-label"
                    label="City Name"
                    value={newData.city_name || ""}
                    onChange={async (e) => {
                      // setCities
                      // console.log("Data111 ------> ", e.target.value);
                      const selectedLocation = data.find(
                        (location) => location.CityName === e.target.value
                      );

                      // setCities(data);

                      // console.log("citiees", cities);
                      // const val1 = GetData(data, e.target.value);

                      console.log(
                        "city_nameeeeeeeeeeee",
                        selectedLocation.LocationID
                      );

                      setNewData({
                        ...newData,
                        city_name: e.target.value,
                        city_id: selectedLocation.LocationID,
                        // city_id: e.
                        // partner_id: e.target.value,
                      });
                    }}
                    // error={!!errors.partner_id}
                  >
                    {!loading &&
                      data?.map((city) => (
                        <MenuItem key={city.LocationId} value={city.CityName}>
                          {city.CityName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.location_name && (
                    <FormHelperText>Location Name is Required</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (
              column.column_name === "partner_id"
              // column.column_name === "partner_name"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="partner-id-label">Partner Name</InputLabel>
                  <Select
                    MenuProps={MenuProps}
                    labelId="partner-id-label"
                    label="Partner Name"
                    value={newData.partner_id || ""}
                    onChange={async (e) => {
                      const { name } = GetData(data[0].partner, e.target.value);

                      setNewData({
                        ...newData,
                        partner_name: name,
                        partner_id: e.target.value,
                      });

                      const stagesAndActivities =
                        await getStagesAndSubActivities(e.target.value);
                      setDependsOn(stagesAndActivities);

                      console.log(
                        "Stages and sub activities",
                        stagesAndActivities
                      );

                      const stageCodes = await getStagesByPartnerId(
                        e.target.value
                      );
                      setStages(stageCodes);

                      const principleData = await getPrincipleByPartnerId(
                        e.target.value
                      );
                      setProjects(principleData);

                      setErrors({
                        ...errors,
                        [column.column_name]: "", // Clear the error message for the column
                      });
                    }}
                    error={!!errors.partner_id}
                  >
                    {!loading &&
                      data[0]?.partner?.map((partner) => (
                        <MenuItem key={partner.id} value={partner.id}>
                          {partner.name}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.partner_id && (
                    <FormHelperText>Partner Name is Required</FormHelperText>
                  )}
                </FormControl>
              );
            }
            if (column.column_name === "domain") {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="domain-label">Domain</InputLabel>
                  <Select
                    labelId="domain-label"
                    label="Domain"
                    value={newData.domain || ""}
                    onChange={(e) =>
                      setNewData({
                        ...newData,
                        domain: e.target.value,
                      })
                    }
                    error={!!errors.domain}
                  >
                    {!loading &&
                      data?.domains?.map((domain) => (
                        <MenuItem key={domain.id} value={domain.domainName}>
                          {domain.domainName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.domain && (
                    <FormHelperText>{errors.domain}</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (
              column.column_name === "role" &&
              selectedTable === "user_role_mapping"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="role-label">Role</InputLabel>
                  <Select
                    labelId="role-label"
                    label="role"
                    value={newData.role || ""}
                    onChange={(e) => {
                      console.log("Event ", e);

                      setErrors({
                        ...errors,
                        [column.column_name]: "", // Clear the error message for the column
                      });

                      setNewData({
                        ...newData,
                        role: e.target.value,
                      });
                    }}
                    // error={!!errors.role}
                  >
                    {!loading &&
                      data?.roles?.map((roles) => (
                        <MenuItem key={roles.id} value={roles.role}>
                          {roles.role}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.role && (
                    <FormHelperText>{errors.role}</FormHelperText>
                    // <span style={{ color: "red" }}>{errors.role}</span>
                  )}
                </FormControl>
              );
            }
            if (column.column_name === "CompanyName") {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="domain-label">Company Name</InputLabel>
                  <Select
                    labelId="domain-label"
                    label="Company Name"
                    value={newData.CompanyName || ""}
                    // onChange={(e) =>
                    //   setNewData({
                    //     ...newData,
                    //     CompanyName: e.target.value,
                    //   })
                    // }
                    onChange={(e) => handleChange(e, column)}
                    error={!!errors.CompanyName}
                  >
                    {!loading &&
                      data?.principles?.map((domain) => (
                        <MenuItem
                          key={domain.ProjectID}
                          value={domain.ProjectName}
                        >
                          {domain.ProjectName}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.CompanyName && (
                    <FormHelperText>{errors.CompanyName}</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (column.column_name === "organization_id") {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="org-label">Organization Name</InputLabel>
                  <Select
                    labelId="org-label"
                    label="Organization Name"
                    value={newData.organization_id || ""}
                    onChange={(e) => {
                      const { name } = GetData(data.orgs, e.target.value);
                      setNewData({
                        ...newData,
                        organization_id: e.target.value,
                        organization_name: name,
                      });
                    }}
                    error={!!errors.organization_id}
                  >
                    {!loading &&
                      data?.orgs?.map((org) => (
                        <MenuItem key={org.id} value={org.id}>
                          {org.name}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors.organization_id && (
                    <FormHelperText>
                      Organization Name is Requried
                    </FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (
              column.column_name === "StageCode" &&
              selectedTable === "ActivityMasterMetadata"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="domain-label">Stage Code</InputLabel>
                  <Select
                    labelId="stage-code-label"
                    label="Stage Code "
                    value={newData.StageCode || ""}
                    // onChange={(e) =>
                    //   setNewData({
                    //     ...newData,
                    //     StageCode: e.target.value,
                    //   })
                    // }
                    onChange={(e) => handleChange(e, column)}
                    error={!!errors.StageCode}
                  >
                    {stages.map((stage) => [
                      <MenuItem key={stage.StageID} value={stage.StageCode}>
                        {stage.StageCode}
                      </MenuItem>,
                    ])}
                  </Select>
                  {errors.StageCode && (
                    <FormHelperText>{errors.StageCode}</FormHelperText>
                  )}
                </FormControl>
              );
            }

            if (column.column_name === "depends_on") {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={!!errors[column.column_name]}
                >
                  <InputLabel id="depend-on-label">Depends On</InputLabel>
                  <Select
                    labelId="depend-on-label"
                    id="depends-on-checkbox"
                    label="Depends On"
                    multiple
                    value={newData.depends_on || []}
                    onChange={(event) => {
                      console.log("Event ", event);
                      const value = event.target.value;
                      console.log("Value selected:", value);
                      setNewData((prev) => {
                        return {
                          ...prev,
                          depends_on:
                            typeof value === "string"
                              ? value.split(",")
                              : value,
                        };
                      });
                    }}
                    renderValue={
                      (selected) =>
                        selected.map((item) => item.split(".")[1]).join(", ") // Extract activity name
                    }
                    MenuProps={MenuProps}
                    error={!!errors.depends_on}
                  >
                    {Object.keys(dependsOn).map((stages) => [
                      <ListSubheader key={`header-${stages}`}>
                        {stages}
                      </ListSubheader>,
                      ...dependsOn[stages].map((activity) => (
                        <MenuItem
                          key={`${stages}.${activity}`}
                          value={`${stages}.${activity}`}
                        >
                          <Checkbox
                            checked={
                              !!newData?.depends_on?.includes(
                                `${stages}.${activity}`
                              )
                            }
                          />
                          <ListItemText primary={`${activity}`} />
                        </MenuItem>
                      )),
                    ])}
                  </Select>
                </FormControl>
              );
            }

            if (
              column.column_name === "phone_number" ||
              column.column_name === "ContactNumber"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={
                    column.column_name === "phone_number" &&
                    newData[column.column_name] &&
                    !/^[0-9]{10}$/.test(newData[column.column_name])
                  }
                >
                  <TextField
                    size="medium"
                    key={column.column_name}
                    margin="dense"
                    label={snakeCasetoTitleCase(column.column_name)}
                    // type={column.data_type === "integer" ? "number" : "text"}
                    type="number"
                    fullWidth
                    value={newData[column.column_name] || ""}
                    onChange={(e) => handleChange(e, column)}
                    error={
                      (column.column_name === "phone_number" ||
                        column.column_name === "ContactNumber") &&
                      newData[column.column_name] &&
                      !/^[6-9]\d{9}$/.test(newData[column.column_name])
                    }
                    helperText={
                      (column.column_name === "phone_number" ||
                        column.column_name === "ContactNumber") &&
                      newData[column.column_name] &&
                      !/^[6-9]\d{9}$/.test(newData[column.column_name])
                        ? "Please enter a valid phone number."
                        : ""
                    }
                    required={column.is_nullable === "NO"}
                    inputProps={{
                      maxLength: column.character_maximum_length || "",
                    }}
                  />
                </FormControl>
              );
            }

            if (
              column.column_name === "email" ||
              column.column_name === "EmailID" ||
              column.column_name === "primary_email"
            ) {
              return (
                <FormControl
                  fullWidth
                  key={column.column_name}
                  margin="dense"
                  error={
                    !!errors[column.column_name] ||
                    (column.column_name === "email" &&
                      newData[column.column_name] &&
                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                        newData[column.column_name]
                      ))
                  }
                >
                  <TextField
                    size="medium"
                    key={column.column_name}
                    margin="dense"
                    label={snakeCasetoTitleCase(column.column_name)}
                    type="email"
                    fullWidth
                    value={newData[column.column_name] || ""}
                    onChange={(e) => handleChange(e, column)}
                    error={
                      !!errors[column.column_name] ||
                      ((column.column_name === "email" ||
                        column.column_name === "EmailID" ||
                        column.column_name === "primary_email") &&
                        newData[column.column_name] &&
                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                          newData[column.column_name]
                        ))
                    }
                    helperText={
                      errors[column.column_name] ||
                      ((column.column_name === "email" ||
                        column.column_name === "EmailID" ||
                        column.column_name === "primary_email") &&
                      newData[column.column_name] &&
                      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                        newData[column.column_name]
                      )
                        ? "Please enter a valid email address."
                        : "")
                    }
                    required={column.is_nullable === "NO"}
                    inputProps={{
                      maxLength: column.character_maximum_length || "",
                    }}
                  />
                </FormControl>
              );
            }

            return (
              <TextField
                size="medium"
                key={column.column_name}
                margin="dense"
                label={snakeCasetoTitleCase(column.column_name)}
                type={column.data_type === "integer" ? "number" : "text"}
                fullWidth
                value={newData[column.column_name] || ""}
                // onChange={(e) =>
                //   setNewData({
                //     ...newData,
                //     [column.column_name]: e.target.value,
                //   })
                // }
                onChange={(e) => handleChange(e, column)}
                error={!!errors[column.column_name]}
                helperText={errors[column.column_name] || ""}
                required={column.is_nullable === "NO"}
                inputProps={{
                  maxLength: column.character_maximum_length || "",
                }}
              />
            );
          })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={handleAdd}
          sx={{
            margin: "16px 0",
            backgroundColor: "#b41660",
            color: "#fff",
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddMasterTableDataModal;
